@if (features) {
  <div class="feature-container">
    @for (feature of features; track feature.id) {
      <tyt-membership-feature
          [feature]="feature"
          [class.active]="hasFeature(feature)"
          />
    }
  </div>
}